// 
// --- Toggle based on environment (match webservice.tsx) ---
// const ServicePath = 'ws://localhost:9015/'          // ← LOCAL DEV
// const ServicePath = "wss://service.dentagenix.com/"  // ← PRODUCTION
const ServicePath = "wss://stagingservice.dentagenix.com/"

export default ServicePath


